var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetPriorityGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.038,
    height: 80.038,
    viewBox: "0 0 80.038 80.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flaga3-13",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_523",
    "data-name": "Ellipse 523",
    cx: 39.019,
    cy: 39.019,
    rx: 39.019,
    ry: 39.019,
    transform: "translate(0)",
    fill: "none",
    stroke: "#2ac147",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 9.932,
    height: 9.223,
    transform: "translate(24.121 19.155)",
    fill: "#2ac147"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 7.804,
    height: 9.223,
    transform: "translate(44.695 19.155)",
    fill: "#2ac147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M75.99,72.5A15.5,15.5,0,1,1,45,72.5",
    transform: "translate(-21.304 -31.609)",
    fill: "none",
    stroke: "#2ac147",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetPriorityGreen);
export default __webpack_public_path__ + "static/media/set-priority-green.3def89864f903ff033f00b4797580a97.svg";
export { ForwardRef as ReactComponent };